import { Checkbox, Popover } from '@faceup/ui-base'
import type { ReactNode } from 'react'
import { twMerge } from 'tailwind-merge'

export type ScrollableCheckboxListOption = {
  id: string
  label: ReactNode
  disabled?: boolean
  popoverContent?: ReactNode
}

export type ScrollableCheckboxListProps = {
  options: ScrollableCheckboxListOption[]
  selectedIds: string[]
  onChange: (id: string, checked: boolean) => void
  'aria-label'?: string
  'aria-describedby'?: string
  maxHeight?: string | number
  className?: string
}

export const ScrollableCheckboxList = ({
  options,
  selectedIds,
  onChange,
  'aria-label': ariaLabel,
  'aria-describedby': ariaDescribedBy,
  maxHeight = 200,
  className,
}: ScrollableCheckboxListProps) => {
  const selected = new Set(selectedIds)

  return (
    <fieldset
      aria-label={ariaLabel}
      aria-describedby={ariaDescribedBy}
      className={twMerge('m-0 p-1 flex flex-col border border-colorBorder rounded-xl', className)}
      style={{ maxHeight }}
    >
      <div className='flex flex-col gap-2 px-3 py-2 overflow-y-auto min-h-0 scrollbar-styled'>
        {options.map(option => {
          const checkbox = (
            <Checkbox
              checked={selected.has(option.id)}
              disabled={option.disabled}
              onChange={e => onChange(option.id, e.target.checked)}
            >
              {option.label}
            </Checkbox>
          )

          if (option.popoverContent) {
            return (
              <Popover key={option.id} placement='bottom' content={option.popoverContent}>
                {checkbox}
              </Popover>
            )
          }

          return <div key={option.id}>{checkbox}</div>
        })}
      </div>
    </fieldset>
  )
}
